<template>
    <div class="users">

        <div class="small-title">
            Opret ny bruger
        </div>

        <form class="create-user" autocomplete="off">
            <input name="hidden" type="text" autocomplete="off" style="display:none;" />
            <div class="row">
                <div class="col-lg-6">
                    <div class="name">
                        <label>Navn *</label>
                        <input type="text" v-model="newUser.name" placeholder="Navn" />
                    </div>
                </div>
                <div :class="{'col-lg-3': newUser.role_id === 4, 'col-lg-6': newUser.role_id !== 4}">
                    <div class="role">
                        <label>Brugerrolle *</label>
                        <select v-model="newUser.role_id">
                            <option :value="2">Administrator</option>
                            <option :value="3">Bruger</option>
                            <option :value="4" v-if="availableDepartments.length > 0">Afdelingsansvarlig</option>
                            <option :value="5">Opgaveansvarlig</option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-3" v-if="newUser.role_id === 4">
                    <div class="department">
                        <label>Vælg afdeling *</label>
                        <select v-model="newUser.relation_department_id">
                            <option selected disabled :value="null">Vælg afdeling ...</option>
                            <option
                                v-for="department in availableDepartments"
                                :key="department.id"
                                v-if="department.name !== 'Virksomheden' && department.name !== 'Ingen afdeling tilknyttet'"
                                :value="department.relation_id"
                            >
                                {{ department.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-lg-3" v-if="newUser.role_id === 5">
                    <div class="department">
                        <label>Vælg medarbejder *</label>
                        <select v-model="newUser.relation_employee_id">
                            <option selected disabled :value="null">Vælg medarbejder ...</option>
                            <option
                                v-for="employee in employees"
                                :key="employee.id"
                                :value="employee.relation_id"
                            >
                                {{ employee.full_name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <div class="email">
                        <label>E-mail *</label>
                        <input type="email" name="iufbw379fb" v-model="newUser.email" placeholder="E-mail" />
                    </div>  
                </div>
                <div class="col-lg-6">
                    <div class="password">
                        <label>Adgangskode *</label>
                        <input type="password" autocomplete="new-password" v-model="newUser.password" placeholder="Adgangskode" />
                        <div class="small">Min. 8 karakterer</div>
                    </div>  
                </div>
            </div>
            <br>
            <div class="action" align="right">
                <div class="pretty-button" @click="createUser()">
                    Opret
                </div>
            </div>
        </form>

        <div class="small" style="margin-top:10px;">
            <div><b>Administrator:</b> Adgang til alle faner og kan ændre indstillinger, administrere brugere mv.</div>
            <div style="margin-top:5px;"><b>Bruger:</b> Læseadgang til alle faner.</div>
            <div style="margin-top:5px;"><b>Afdelingsansvarlig:</b> Læseadgang til alle faner undtagen økonomi-relaterede faner og potentiale. Kan kun se data for sin egen afdeling.</div>
            <div style="margin-top:5px;"><b>Opgaveansvarlig:</b> Læseadgang til ens personlige værdikæde.</div>
        </div>
        
        <div class="divider" />
        
        <div class="small-title">
            Alle brugere
        </div>

        <div class="list" v-if="users && !loading">
            <div class="row">
                <div class="col-lg-6" v-for="user in sortedUsers" :key="user.uuid">
                    <div class="user">
                        <div class="name">
                            <input type="text" v-model="user.name" />
                        </div>
                        <div class="role">
                            <select v-model="user.role_id" @change="user.name = user.name + ' '; user.name = user.name.slice(0, -1)">
                                <option :value="2">Administrator</option>
                                <option :value="3">Bruger</option>
                                <option :value="4">Afdelingsansvarlig</option>
                                <option :value="5">Opgaveansvarlig</option>
                            </select>
                        </div>
                        <div class="department" v-if="user.role_id === 4">
                            <select v-model="user.relation_department_id">
                                <option selected disabled :value="null">Vælg afdeling ...</option>
                                <option
                                    v-for="department in availableDepartments"
                                    :key="department.id"
                                    v-if="department.name !== 'Virksomheden' && department.name !== 'Ingen afdeling tilknyttet'"
                                    :value="department.relation_id"
                                >
                                    {{ department.name }}
                                </option>
                            </select>
                        </div>
                        <div class="department" v-if="user.role_id === 5">
                            <select v-model="user.relation_employee_id">
                                <option selected disabled :value="null">Vælg medarbejder ...</option>
                                <option
                                    v-for="employee in employees"
                                    :key="employee.id"
                                    :value="employee.relation_id"
                                >
                                    {{ employee.full_name }}
                                </option>
                            </select>
                        </div>
                        <div class="email">
                            <input type="email" v-model="user.email" />
                        </div>
                        <div class="password">
                            <input type="password" v-model="user.new_password" placeholder="Evt. ny adgangskode" />
                        </div>
                        <div class="actions">
                            <div class="action" @click="updateUser(user)">
                                Opdatér
                            </div>
                            <div class="action" @click="deleteUser(user)">
                                Slet
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <box-loading height="350" v-else />

    </div>
</template>

<style lang="scss" scoped>
@import "../../../styles/vars.scss";

    .small {
        font-size: $fontsize--small;
    }

    .users {

        .small-title {
            font-size: $fontsize--medium;
            margin-bottom: $margin--small;
        }

        .create-user {
            background: $color--white;
            padding: $padding--main;
            border-radius: $borderradius--main;
            box-shadow: $boxshadow--creative;

            .small {
                font-size: $fontsize--small;
                margin-top: 4px;
            }

            label {
                font-weight: 600;
                margin-bottom: 5px;
                display: block;
            }

            input, select {
                height: 40px;
                padding: 4px 10px;
                border: 1px solid rgba(0, 0, 0, 0.15);
                box-sizing: border-box;
                border-radius: $borderradius--main;
                cursor: pointer;
                width: 100%;
                // margin-bottom: $margin--small;
            }
        }

        .list {

            .user {
                padding: $padding--main;
                background: $color--white;
                border-radius: $borderradius--main;
                box-shadow: $boxshadow--creative;
                margin-bottom: -$margin--main;

                input, select {
                    height: 40px;
                    padding: 4px 10px;
                    border: 1px solid rgba(0, 0, 0, 0.15);
                    box-sizing: border-box;
                    border-radius: $borderradius--main;
                    cursor: pointer;
                    width: 100%;
                    margin-bottom: $margin--small;
                }

                .name {
                    flex: 0 0 30%;
                    font-weight: 600;

                    .role {
                        font-weight: normal;
                        font-size: $fontsize--sm;
                    }
                }

                .email {
                    flex: 0 0 30%;
                }

                .password {
                    flex: 0 0 25%;
                }

                .actions {
                    flex: 0 0 15%;
                    display: flex;
                    justify-content: space-between;

                    .action {
                        cursor: pointer;
                    }
                }

                &:not(:last-of-type) {
                    margin-bottom: $margin--small;
                }
            }
        }
    }

</style>

<script>
import * as userService from '@/services/userService'
import * as employeeService from '@/services/employeeService'

export default {
    data () {
        return {
            loading: false,
            availableDepartments: [],
            newUser: {
                name: '',
                email: '',
                role_id: 3,
                password: '',
                relation_department_id: null,
                relation_employee_id: null
            },
            users: null,
            employees: null
        }
    },
    created () {
        this.getEmployees()
        this.getUsers()
        this.availableDepartments = this.$store.getters.getAvailableDepartments
    },
    methods: {
        getEmployees () {
            employeeService.findAll({}, (response) => {
                this.employees = response.data
                console.log('employees', this.employees)
                console.log('Torben Larsen', this.employees.filter(x => x.full_name === 'Torben Larsen '))
            }, (err) => {
                console.log(err)
            })
        },
        getUsers () {
            this.loading = true
            userService.all({}, (response) => {
                this.users = response.data
                console.log(this.users)
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        },
        resetFields () {
            this.newUser = {
                name: '',
                email: '',
                role_id: 3,
                password: ''
            }
        },
        createUser () {
            if (this.$auth.user().name.includes('Demo')) {
                alert('Det er ikke muligt at ændre indstillinger i demo-versionen.')
                return
            }
            if (this.newUser.role_id === 4 && !this.newUser.relation_department_id) {
                alert('Du skal angive en afdeling til den afdelingsansvarlige for at oprette brugeren.')
                return
            }
            if (this.newUser.role_id === 4 && !this.newUser.relation_employee_id) {
                alert('Du skal angive en medarbejder til den opgaveansvarlige for at oprette brugeren.')
                return
            }
            let body = {
                name: this.newUser.name,
                email: this.newUser.email,
                role_id: this.newUser.role_id,
                relation_department_id: this.newUser.relation_department_id,
                relation_employee_id: this.newUser.relation_employee_id,
                password: this.newUser.password,
                password_confirmation: this.newUser.password
            }
            userService.create(body, (response) => {
                this.$toastr('success', 'Brugeren blev oprettet', 'Sådan!')
                this.getUsers()
                this.resetFields()
            }, (err) => {
                this.$toastr('error', 'Der skete en fejl ved oprettelse af brugeren', 'Hovsa!')
                console.log(err)
            })
        },
        updateUser (user) {
            if (this.$auth.user().name.includes('Demo')) {
                alert('Det er ikke muligt at ændre indstillinger i demo-versionen.')
                return
            }
            if (user.role_id === 4 && !user.relation_department_id) {
                alert('Vælg en afdeling til den afdelingsansvarlige for at opdatere brugeren.')
                return
            }
            if (user.role_id === 4 && !user.relation_employee_id) {
                alert('Vælg en medarbejder til den opgaveansvarlige for at opdatere brugeren.')
                return
            }
            let body = {
                name: user.name,
                email: user.email,
                role_id: user.role_id,
                relation_department_id: user.relation_department_id,
                relation_employee_id: user.relation_employee_id
            }
            if (user.new_password) {
                body.password = user.new_password
                body.password_confirmation = user.new_password
            }
            userService.update(user.uuid, body, (response) => {
                this.$toastr('success', 'Brugeren blev opdateret', 'Sådan!')
                this.getUsers()
            }, (err) => {
                console.log(err)
                this.$toastr('error', 'Der skete en fejl ved opdatering af brugeren', 'Hovsa!')
            })
        },
        deleteUser (user) {
            if (this.$auth.user().name.includes('Demo')) {
                alert('Det er ikke muligt at ændre indstillinger i demo-versionen.')
                return
            }
            userService.remove(user.uuid, (response) => {
                this.$toastr('success', 'Brugeren blev slettet', 'Sådan!')
                this.getUsers()
            }, (err) => {
                console.log(err)
                this.$toastr('error', 'Der skete en fejl ved sletning af brugeren', 'Hovsa!')
            })
        }
    },
    computed: {
        sortedUsers () {
            if (this.users) {
                let users = []
                this.users.forEach((user) => {
                    if (user.roles[0].name !== 'super-admin') {
                        user.role_id = user.roles[0].id
                        user.new_password = null
                        users.push(user)
                    }
                })
                return users
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// users.vue?7c50baf8